// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.home_Home__1qO-1 {
  background-color: #efeeed;
  /* margin: 0; */
  /* height: 100vh; */
  /* max-width: 1300px; */
  /* margin-left: auto;
    margin-right: auto; */
  /* padding: 0 10px; */
  /* padding: 0; */
}

.home_homeContainer__u-okH {
  /* background-color: #F3F2F0; */
  height: 131vh;
}


/* .container {
  padding: 0 85px;
}

@media screen and (min-width: 769px) and (max-width: 920px) {
  .container{
    padding: 0 30px;
  }
}

@media screen and (max-width: 768px) {
  .container{
    padding: 0 100px;
  }
} */

.home_notifications__L148I {
  display: flex; 
  padding: 10px 0px 10px 15px;
  border-radius: 25px;
  background-color: #ffffff;
  position: absolute;
  right: 1%;
  box-shadow: 0px 3px 6px #00000029;
  z-index: 555;
}
@media screen and (min-width: 1024px){
  .home_notifications__L148I{
    width: 350px;
  }
}
.home_notificationscroll__NYZ9C {
  padding-right: 7px;
  overflow-y: scroll;
  height: 818px;
  scrollbar-width: thin;
  scrollbar-color: #6b71c9;
  width: -moz-available;
}
.home_notificationscroll__NYZ9C::-webkit-scrollbar {
  width: 4px;
}
.home_notificationscroll__NYZ9C::-webkit-scrollbar-thumb {
  background: #707070;
  border-radius: 10px;
}
.home_notificationscroll__NYZ9C::-webkit-scrollbar-thumb:hover {
  background: #6b71c9;
}
@media all and (max-width: 991px) {
  .home_homeRow__B8ois {
    display: flex;
    flex-direction: column;
  }
  .home_homeRow__B8ois .home_leftColumn__ZcnhK {
    order: 2;
  }
  .home_homeRow__B8ois .home_rightColumn__Imjhj {
    order: 1;
  }
  .home_homeRow__B8ois .home_midColumn__BFZZX {
    order: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Assets/css/home/home.module.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB;yBACuB;EACvB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,aAAa;AACf;;;AAGA;;;;;;;;;;;;;;GAcG;;AAEH;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,SAAS;EACT,iCAAiC;EACjC,YAAY;AACd;AACA;EACE;IACE,YAAY;EACd;AACF;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,qBAAqB;EACrB,wBAAwB;EACxB,qBAAqB;AACvB;AACA;EACE,UAAU;AACZ;AACA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE;IACE,aAAa;IACb,sBAAsB;EACxB;EACA;IACE,QAAQ;EACV;EACA;IACE,QAAQ;EACV;EACA;IACE,QAAQ;EACV;AACF","sourcesContent":[".Home {\r\n  background-color: #efeeed;\r\n  /* margin: 0; */\r\n  /* height: 100vh; */\r\n  /* max-width: 1300px; */\r\n  /* margin-left: auto;\r\n    margin-right: auto; */\r\n  /* padding: 0 10px; */\r\n  /* padding: 0; */\r\n}\r\n\r\n.homeContainer {\r\n  /* background-color: #F3F2F0; */\r\n  height: 131vh;\r\n}\r\n\r\n\r\n/* .container {\r\n  padding: 0 85px;\r\n}\r\n\r\n@media screen and (min-width: 769px) and (max-width: 920px) {\r\n  .container{\r\n    padding: 0 30px;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 768px) {\r\n  .container{\r\n    padding: 0 100px;\r\n  }\r\n} */\r\n\r\n.notifications {\r\n  display: flex; \r\n  padding: 10px 0px 10px 15px;\r\n  border-radius: 25px;\r\n  background-color: #ffffff;\r\n  position: absolute;\r\n  right: 1%;\r\n  box-shadow: 0px 3px 6px #00000029;\r\n  z-index: 555;\r\n}\r\n@media screen and (min-width: 1024px){\r\n  .notifications{\r\n    width: 350px;\r\n  }\r\n}\r\n.notificationscroll {\r\n  padding-right: 7px;\r\n  overflow-y: scroll;\r\n  height: 818px;\r\n  scrollbar-width: thin;\r\n  scrollbar-color: #6b71c9;\r\n  width: -moz-available;\r\n}\r\n.notificationscroll::-webkit-scrollbar {\r\n  width: 4px;\r\n}\r\n.notificationscroll::-webkit-scrollbar-thumb {\r\n  background: #707070;\r\n  border-radius: 10px;\r\n}\r\n.notificationscroll::-webkit-scrollbar-thumb:hover {\r\n  background: #6b71c9;\r\n}\r\n@media all and (max-width: 991px) {\r\n  .homeRow {\r\n    display: flex;\r\n    flex-direction: column;\r\n  }\r\n  .homeRow .leftColumn {\r\n    order: 2;\r\n  }\r\n  .homeRow .rightColumn {\r\n    order: 1;\r\n  }\r\n  .homeRow .midColumn {\r\n    order: 0;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Home": `home_Home__1qO-1`,
	"homeContainer": `home_homeContainer__u-okH`,
	"notifications": `home_notifications__L148I`,
	"notificationscroll": `home_notificationscroll__NYZ9C`,
	"homeRow": `home_homeRow__B8ois`,
	"leftColumn": `home_leftColumn__ZcnhK`,
	"rightColumn": `home_rightColumn__Imjhj`,
	"midColumn": `home_midColumn__BFZZX`
};
export default ___CSS_LOADER_EXPORT___;
